import React from 'react';
import { BookOpen } from 'lucide-react';
import { Publication } from '../../types';

interface PublicationsListProps {
  publications: (Publication & { currentQuantity?: number })[];
}

const PublicationsList: React.FC<PublicationsListProps> = ({ publications }) => {
  if (publications.length === 0) {
    return (
      <p className="text-gray-500 dark:text-gray-300 text-center py-4">
        Aucune publication disponible
      </p>
    );
  }

  return (
    <div className="space-y-2">
      {publications.map((publication) => (
        <div key={publication.id} className="p-4 bg-gray-50 dark:bg-gray-800 rounded-lg">
          <div className="flex items-center gap-3">
            {publication.imageUrl ? (
              <img 
                src={publication.imageUrl} 
                alt={publication.title}
                className="w-16 h-16 rounded object-cover"
              />
            ) : (
              <div className="w-16 h-16 bg-gray-200 dark:bg-gray-700 rounded flex items-center justify-center">
                <BookOpen className="h-8 w-8 text-gray-400 dark:text-gray-500" />
              </div>
            )}
            <div className="flex-1">
              <div className="flex items-center justify-between">
                <h3 className="font-medium text-gray-900 dark:text-gray-100">{publication.title}</h3>
                {typeof publication.currentQuantity === 'number' && (
                  <span className="px-2 py-1 rounded text-xs font-semibold bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300">
                    {publication.currentQuantity}
                  </span>
                )}
              </div>
              {publication.description && (
                <p className="text-sm text-gray-600 dark:text-gray-300 mt-1">{publication.description}</p>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PublicationsList;